export enum InventoryManagement
{
    StockItemMaster = 69,
    StockItemTypeMaster = 70,
    StoreLocationMaster = 71,
    //CreateStoreLocationMaster = 525,
    BinMaster = 218,
    StockUomMaster = 219,
    ItemMainGroupMaster = 220,
    ItemSubGroupMaster = 221,
    BinMaintenance = 222,
    StockItemPlanning = 20272,
    OtherStockLocationMaster = 20354,
    StockItemBulkUpdate = 20370,
    StockItemDetailUpdate = 20433,
    LocationBulkUpdate = 20407,
    SubLocationBulkUpdate = 20408,
    TagMaster = 20542,
    StockItemUpdate = 20574


}

export enum PermissionType {
  Create = 1,
  Read = 2,
  Update = 3,
  Delete = 4,
  //Search = 5,
  Print = 6,
  Execute = 7
}

export enum ScreenState {
  New = 1,
  Edit = 2,
  ViewFromGrid = 3,
  ViewFromCode = 4,
  ViewFromCodeRequest = 5
}